import React from 'react';
import { Box, Typography } from '@mui/material';

const DrawerUserInfo = ({ user }) => {
  return (
    <>
      <Box
        sx={{
          py: 2,
          backgroundColor: '#37474f',
          color: '#fff',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography variant="subtitle1" component="div" sx={{ mb: 1 }}>
            {user?.usrNm} {user?.gradeNm}
          </Typography>
          <Typography
            variant="body2"
            component="div"
            sx={{ mb: 0.1, color: '#e0e0e0' }}
          >
            {user?.dptNm}
          </Typography>
        </Box>

        {/* <Box sx={{ py: 1, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                    {user.profileImg ? (
                        <Avatar alt={user.usrNm} src={user.profileImg} sx={{ width: 56, height: 56 }} />
                    ) : (
                        <Avatar sx={{ width: 56, height: 56 }}>
                            {user.usrNm.substring(0, 1)}
                        </Avatar>
                    )}
                </Box> */}
      </Box>
    </>
  );
};

export default DrawerUserInfo;
